// @mui
import { List, Box, ListSubheader } from '@mui/material'
import { styled } from '@mui/material/styles'

// type
import { NavSectionProps } from '../type'

//
import { NavListRoot } from './NavList'

import useAuth from 'src/hooks/useAuth'

export const ListSubheaderStyle = styled((props) => (
  <ListSubheader disableSticky disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.overline,
  paddingTop: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  color: theme.palette.text.primary,
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter
  })
}))

export default function NavSectionVertical({
  navConfig,
  isCollapse = false,
  ...other
}: NavSectionProps) {
  const { user } = useAuth()
  const currentRole = (user?.role as string) || ''

  return (
    <Box {...other}>
      {navConfig.map((group, idx) => {
        const visibleItems = group.items.filter(
          (item) => !item.roles || item.roles.includes(currentRole)
        )

        if (visibleItems.length === 0) return null

        return (
          <List key={`${group.subheader}-${idx}`} disablePadding>
            <ListSubheaderStyle
              sx={{
                ...(isCollapse && {
                  opacity: 0
                })
              }}
            >
              {group.subheader}
            </ListSubheaderStyle>

            {visibleItems.map((list) => (
              <NavListRoot
                key={list.title}
                list={list}
                isCollapse={isCollapse}
              />
            ))}
          </List>
        )
      })}
    </Box>
  )
}
